export default {
  settings: [],

  workStations: [],
  workStationCode: null,

  workShifts: [],
  workShiftCode: null,

  boms: [],
  bom: {},
  bomCode: null,
  bomCommodities: [],

  orders: [],
  order: {},
  orderCode: null,

  orderDetails: [],

  ordersSetting: [],
  orderSetting: {},

  foilCartable: [],

  financialProductionCartable: [],

  casterCartable: [],

  coldRollCartable: [],

  saleCartable: [],

  managerProductionCartable: [],

  productionCartable: [],

  supplyAndEquipmentCartable: [],

  managerSupplyCartable: [],

  financialSupplyCartable: [],

  orderDetailConfirmLog: [],

  reqProduces: [],
  reqProduce: {},
  reqProduceCode: null,

  reqProduceDetails: [],

  produceOrderFinancialCartable: [],

  produceOrderManagerCartable: [],

  produceOrderProcessCartable: [],

  produceProcesses: [],
  produceProcess: {},

  productionReports: [],
  productionReport: {},
  casterProductionReports: [],
  productionReportCode: null,
  productionReportCoilNumber: null,
  productionReportMaterials: [],
  productionReportReadonlyFields: {},

  processTypes: [],

  produceOrders: [],
  produceOrder: {},
  produceOrderCode: null,
  produceOrderCartable: [],

  sprints: [],
  sprintCode: null,
  currentSprint: {},

  coilCertificates: [],
  coilCertificate: {},
  coilCertificateCode: null,

  coldRollingProductionReports: [],

  foilRollingProductionReports: [],

  qcCasters: [],

  qcColdRollings: [],

  qcFoilRollings: [],

  orderCommodity: [],

  hardnesses: [],
  hardnessCode: null,

  productSurfaces: [],
  productSurfaceCode: null,

  usageGroups: [],
  usageGroupCode: null,

  foilUsages: [],
  foilUsageCode: null,

  innerCoreDiameters: [],
  innerCoreDiameterCode: null,

  produceOrderCastings: [],

  cartableCasting: [],

  cartableColdRolling: [],

  cartableFoilRolling: [],

  managementCartableCasting: [],

  managementCartableColdRolling: [],

  managementCartableFoilRolling: [],

  printLink: null,

  produceOrderColdRollings: [],

  produceOrderFoilRollings: [],

  furnaces: [],
  furnace: {},
  furnaceCode: null,

  cartableLog: [],
};
